var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3EE9E5",
    fillRule: "evenodd",
    d: "M10.057 0c5.01 0 9.166 3.664 9.931 8.46a8.172 8.172 0 01-11.53 11.528C3.664 19.221 0 15.067 0 10.057 0 4.502 4.503 0 10.057 0zm3.757 5.657a8.171 8.171 0 00-5.356 14.33 10.083 10.083 0 002.421.094 6.914 6.914 0 119.202-9.203 10.06 10.06 0 01-9.202 9.203 6.914 6.914 0 009.202-9.203 10.252 10.252 0 00-.093-2.418 8.15 8.15 0 00-6.174-2.803z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaker);
export default __webpack_public_path__ + "static/media/maker.b6f34b7909e60ded181acb3108eb39c3.svg";
export { ForwardRef as ReactComponent };